import { Companion } from "../../classes";
import moment from "moment";
const CompanionModule = {
  namespaced: true,
  state: {
    companions: [],
    companion: {},
    search: "",
    searchCompanions: [],
    projectCompanions: [],
    projectCompanionCount: 0
  },
  actions: {
    getCompanions: async ({ commit, rootGetters }, payload) => {
      try {
        const data = await Companion.getCompanionsByMarket({
          projectId: rootGetters["markets/getProjectId"]
        });
        commit("setCompanions", { companion: data });
        return data;
      } catch (err) {
        throw err;
      }
    },
    getCompanion: async ({ commit }, payload) => {
      try {
        const data = await Companion.getCompanion({ id: payload.id });
        commit("setCompanion", { companion: data });
        return data;
      } catch (err) {
        throw err;
      }
    },
    createCompanion: async ({ dispatch, commit }, payload) => {
      try {
        const data = await Companion.createCompanion(payload);
        // dispatch("getCompanions");
        // commit("addProjectCompanion", data);
        return data;
      } catch (err) {
        throw err;
      }
    },
    updateCompanion: async ({ commit }, payload) => {
      try {
        const data = await Companion.updateCompanion(payload);
        // commit("setCompanion", { companion: data });
        // commit("setCompanions", data);
        return data;
      } catch (err) {
        throw err;
      }
    },
    getCompanionByKeyword: async ({ commit, rootGetters }, payload) => {
      try {
        const data = await Companion.getCompanionByKeyword({
          keyword: payload.keyword,
          projectId: rootGetters["markets/getProjectId"]
        });
        commit("setSearchCompanion", data);
        if (!payload.onlySearch) commit("setCompanions", data);
        return data;
      } catch (err) {
        return false;
      }
    },
    getCompanionsByProject: async (
      { commit },
      { projectId, limit, page, order }
    ) => {
      try {
        const data = await Companion.getCompanionsByProject(
          projectId,
          limit,
          page,
          order
        );
        commit("setCompanions", data);
        return data;
      } catch (err) {
        throw err;
      }
    },
    getCompanionsByCustomer: async ({ commit }, payload) => {
      try {
        const data = await Companion.getCompanionsByCustomer(payload);
        commit("setCompanions", data);
        return data;
      } catch (err) {
        throw err;
      }
    },

  },
  getters: {
    getCompanion: state => state.companion,
    getCompanions: state => state.companions,
    getSearchCompanions: state =>
      state.searchCompanions.map(i => {
        i.label = i.labelSearch;
        return i;
      }),
  },
  mutations: {
    setCompanion: (state, companion) => {
      state.companion = companion;
    },
    setCompanions: (state, companions) => {
      state.companions = companions;
    },
    setSearchCompanion: (state, searchCompanions) => {
      state.searchCompanions = searchCompanions;
    },
  }
};
export default CompanionModule;
